import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('/api/jean') || req.url.startsWith('/api/category') || req.url.startsWith('/api/producer')) {
      req = req.clone({url: `${environment.api.baseUrl}${req.url}`, withCredentials: true})
    } else if (req.url.startsWith('/api/user')) {
      req = req.clone({url: `${environment.api.identityUrl}${req.url}`, withCredentials: true})
    } else {
      req = req.clone({withCredentials: true})
    }
    return next.handle(req)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/http/api.interceptor.ts